import { type ReactElement, useEffect } from 'react'
import { useSnapshot } from 'valtio'
import { Dialog } from '@headlessui/react'
import cn from 'classnames'
import Label from '../ui/forms/Label'
import { proxyGlobalAuth } from '../../proxies/proxyGlobalAuth'
import {
  autoLogoutProxy,
  hideTimeoutModal, logoutUser,
  resetInactivityTimeoutId,
  resetLogoutTimeoutId
} from './autoLogoutProxy'

export function AutoLogoutModal (): ReactElement {
  const { isTimeoutModalShown } = useSnapshot(autoLogoutProxy)
  const { siteTheme: { buttonColors } } = useSnapshot(proxyGlobalAuth)

  useEffect(() => {
    function handleUserActivity (): void {
      hideTimeoutModal()
    }

    function resetTimeouts (): void {
      resetInactivityTimeoutId()
      resetLogoutTimeoutId()
    }

    resetTimeouts()

    document.addEventListener('click', handleUserActivity)
    document.addEventListener('keydown', handleUserActivity)

    return () => {
      document.removeEventListener('click', handleUserActivity)
      document.removeEventListener('keydown', handleUserActivity)
      resetTimeouts()
    }
  }, [])

  return (
    <Dialog
      open={isTimeoutModalShown}
      onClose={hideTimeoutModal}
      className="fixed z-10 inset-0 overflow-y-auto"
    >
      <div className="flex items-center justify-center min-h-screen">
        <Dialog.Overlay className="fixed inset-0 bg-black opacity-30" />

        <div className="relative bg-white rounded max-w-2xl mx-auto p-5">
          <Dialog.Title>
            <div className="mb-4">
              <div className="text-xl font-medium">Inactivity Timeout</div>
              <hr />
            </div>
          </Dialog.Title>
          <Label text="You have been inactive for some time. Do you want to continue your session?" />
          <div className="flex justify-between mt-6">
            <button
              className={cn(
                buttonColors.classes,
                'w-48 flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white focus:outline-none focus:ring-2 focus:ring-offset-2'
              )}
              onClick={hideTimeoutModal}
            >Continue
            </button>
            <button
              className={cn(
                buttonColors.secondaryClasses,
                'w-36 flex justify-center py-2 px-4 rounded-md text-sm font-medium focus:outline-none'
              )}
              onClick={logoutUser}
            >Log out
            </button>
          </div>

        </div>
      </div>
    </Dialog>

  )
}
